import { StringKey } from '../../../../lang/index';
import {
  categoryLabelKey,
  ExpirationPeriod,
  expirationPeriodLabelKey,
  subCategoryLabelKey,
  TemplateCategory,
  TemplateSubCategory,
} from '../enums/template.const';

export const TEMPLATE_FORM_CATEGORIES = [TemplateCategory.GRANT] as const;

export const categoryOptions = TEMPLATE_FORM_CATEGORIES.map((value) => ({
  labelKey: categoryLabelKey[value],
  value,
}));

export type CategoryValue = TemplateCategory;

export const subCategoryByCategory: Partial<
  Record<TemplateCategory, { labelKey: StringKey; value: TemplateSubCategory }[]>
> = {
  [TemplateCategory.GRANT]: [
    {
      labelKey: subCategoryLabelKey[TemplateSubCategory.GRANT_AGREEMENT],
      value: TemplateSubCategory.GRANT_AGREEMENT,
    },
  ],
};

export const expirationPeriodOptions = Object.values(ExpirationPeriod)
  .filter((v): v is ExpirationPeriod => typeof v === 'string')
  .map((value) => ({
    labelKey: expirationPeriodLabelKey[value],
    value,
  }));
